import { atom } from "recoil";

export const sharedValuesState = atom<Record<string, any>>({
  key: "shared-values",
  default: {},
});
